import { Loader } from '@oy/uidesktop';
import React from 'react';
import { useTranslate } from 'src/hooks';
import styles from './MainLoader.module.css';

const MainLoader = () => {
  const { getTranslation } = useTranslate();

  return (
    <div className={styles.center}>
      <Loader title={getTranslation('common_pleaseWait')} />
    </div>
  );
};

export default MainLoader;
